/**
 * See: http://www.emtresource.com/resources/guides/normal-vital-signs/
 * @param age 
 */
function getNormalHeartRateRange(age: number) {
    if (age < 1) {
        return [120, 150]
    } else if (age < 5) {
        return [80, 150]
    } else if (age < 12) {
        return [60, 120]
    } else if (age < 18) {
        return [60, 105]
    } else {
        return [60, 100]
    }
}

/**
 * See: http://www.emtresource.com/resources/guides/normal-vital-signs/
 * @param age 
 */
function getNormalRespirationRange(age: number) {
    if (age < 1) {
        return [25, 50]
    } else if (age < 12) {
        return [15, 30]
    } else {
        return [12, 20]
    }
}

/**
 * See: http://www.emtresource.com/resources/guides/normal-vital-signs/
 * @param age 
 */
function getNormalSpo2Range(age: number) {
    return [97, 100]
}

/**
 * See: http://www.emtresource.com/resources/guides/normal-vital-signs/
 * @param age 
 */
function getNormalSystolicRange(age: number, gender: string) {
    if (age < 1) {
        return [70, 71]
    } else if (age < 10) {
        return [70 + 2 * age, 90 + 2 * age]
    } else if (age < 18) {
        return [70 + 2 * age, 90 + 2 * age]
    } else {
        if (gender === "M") {
            return [100 + Math.max(40, age), 101 + Math.max(40, age)]
        } else {
            return [90 + Math.max(40, age), 91 + Math.max(40, age)]
        }
    }
}

/**
 * See: http://www.emtresource.com/resources/guides/normal-vital-signs/
 * @param age 
 */
function getNormalDiastolicRange(age: number, gender: string) {
    if (age < 18) {
        return [getNormalSystolicRange(age, gender)[0] * 2/3, getNormalSystolicRange(age, gender)[1] * 2/3]
    } else {
        return [60, 90]
    }
}

/**
 * Consider: Heart rate variability as a biobehavioral marker of diverse psychopathologies: A review and argument for an “ideal range”
 * But methodology may differ
 * See: Heart rate variability as a biobehavioral marker of diverse psychopathologies: A review and argument for an “ideal range”
 */
function getNormalHRVRange() {
    return [28.80, 101.00]
}

/**
 * See: https://journals.lww.com/ccmjournal/Fulltext/2002/06000/Bactericidal_permeability_increasing.6.aspx
 */
function getNormalPerfRange() {
    return [0.3, 10]
}


export async function getNormalVitalSignRange(age: number, gender: string): Promise<any> {
    return [{
        "hr_lower": getNormalHeartRateRange(age)[0],
        "hr_upper": getNormalHeartRateRange(age)[1],
        "rr_lower": getNormalRespirationRange(age)[0],
        "rr_upper": getNormalRespirationRange(age)[1],
        "spo2_lower": getNormalSpo2Range(age)[0],
        "spo2_upper": getNormalSpo2Range(age)[1],
        "nbps_lower": getNormalSystolicRange(age, gender)[0],
        "nbps_upper": getNormalSystolicRange(age, gender)[1],
        "nbpd_lower": getNormalDiastolicRange(age, gender)[0],
        "nbpd_upper": getNormalDiastolicRange(age, gender)[1],
        "hrv_lower": getNormalHRVRange()[0],
        "hrv_upper": getNormalHRVRange()[1],
        "perf_lower": getNormalPerfRange()[0],
        "perf_upper": getNormalPerfRange()[1],
    }]
}
